import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './../shared/services/auth-guard.service';
import { AdminAuthGuard } from './../shared/services/admin-auth-guard.service';

import { AdminComponent } from './admin.component';
import { HomeComponent } from './components/home/home.component';
import { UserListComponent } from './components/user/user-list/user-list.component';
import { ProfileFormComponent } from './components/user/profile-form/profile-form.component';
import { ChangePasswordFormComponent } from './components/user/change-password-form/change-password-form.component';
import { MediaFileListComponent } from './components/media-file/media-file-list/media-file-list.component';
import { CmsPageFormComponent } from './components/cms-page/cms-page-form/cms-page-form.component';
import { CmsPageListComponent } from './components/cms-page/cms-page-list/cms-page-list.component';
import { MenuContentFormComponent } from './components/menu-content/menu-content-form/menu-content-form.component';
import { MenuContentListComponent } from './components/menu-content/menu-content-list/menu-content-list.component';
import { MenuFormComponent } from './components/menu/menu-form/menu-form.component';
import { MenuListComponent } from './components/menu/menu-list/menu-list.component';
import { FAQCategoryFormComponent } from './components/faq-category/faq-category-form/faq-category-form.component';
import { FAQCategoryListComponent } from './components/faq-category/faq-category-list/faq-category-list.component';
import { FAQFormComponent } from './components/faq/faq-form/faq-form.component';
import { FAQListComponent } from './components/faq/faq-list/faq-list.component';
import { NoticeBoardFormComponent } from './components/notice-board/notice-board-form/notice-board-form.component';
import { NoticeBoardListComponent } from './components/notice-board/notice-board-list/notice-board-list.component';
import { NoticeBoardCategoryFormComponent } from './components/notice-board-category/notice-board-category-form/notice-board-category-form.component';
import { NoticeBoardCategoryListComponent } from './components/notice-board-category/notice-board-category-list/notice-board-category-list.component';
import { FeedbackListComponent } from './components/feedback/feedback-list/feedback-list.component';
import { FeedbackFormComponent } from './components/feedback/feedback-form/feedback-form.component';
import { RegionListComponent } from './components/region/region-list/region-list.component';
import { RegionFormComponent } from './components/region/region-form/region-form.component';
import { StateListComponent } from './components/state/state-list/state-list.component';
import { StateFormComponent } from './components/state/state-form/state-form.component';
import { DistrictListComponent } from './components/district/district-list/district-list.component';
import { DistrictFormComponent } from './components/district/district-form/district-form.component';
import { SchoolListComponent } from './components/school/school-list/school-list.component';
import { SchoolFormComponent } from './components/school/school-form/school-form.component';
import { SanctionedPostListComponent } from './components/sanctioned-post/sanctioned-post-list/sanctioned-post-list.component';
import { SanctionedPostFormComponent } from './components/sanctioned-post/sanctioned-post-form/sanctioned-post-form.component';
import { VacantPostListComponent } from './components/vacant-post/vacant-post-list/vacant-post-list.component';
import { VacantPostFormComponent } from './components/vacant-post/vacant-post-form/vacant-post-form.component';
import { SettingFormComponent } from './components/setting/setting-form/setting-form.component';
import { EmployeeProfileListComponent } from './components/employee-profile/employee-profile-list/employee-profile-list.component';
import { EmployeeProfileViewComponent } from './components/employee-profile/employee-profile-view/employee-profile-view.component';
import { GrievanceComponent } from './components/grievance/grievance.component';
import { EmployerViewComponent } from './components/grievance/employer-view/employer-view.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: "Admin" },
    component: AdminComponent,
    canActivate: [AuthGuard, AdminAuthGuard],
    children: [
      {
        path: '',
        data: { breadcrumb: 'Home' },
        component: HomeComponent
      },
      {
        path: 'users',
        data: { breadcrumb: "Users" },
        children: [
          { path: '', component: UserListComponent, data: { breadcrumb: "Users" } },
          { path: 'edit-profile/:id', component: ProfileFormComponent, data: { breadcrumb: "Edit" } },
          { path: 'change-password/:id', component: ChangePasswordFormComponent, data: { breadcrumb: "Edit" } }
        ]
      },
      {
        path: 'media-files',
        data: { breadcrumb: "Media Files" },
        children: [
          { path: '', component: MediaFileListComponent, data: { breadcrumb: "Media Files" } }
        ]
      },
      {
        path: 'setting',
        data: { breadcrumb: "Setting" },
        children: [
          { path: '', component: SettingFormComponent, data: { breadcrumb: "Setting" } }
        ]
      },
      {
        path: 'menus',
        data: { breadcrumb: "Menu" },
        children: [
          { path: '', component: MenuListComponent, data: { breadcrumb: "Menu" } },
          { path: 'new', component: MenuFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: MenuFormComponent, data: { breadcrumb: "Edit" } },
          {
            path: 'menu-contents',
            data: { breadcrumb: "Menu Content" },
            children: [
              { path: ':menuId', component: MenuContentListComponent, data: { breadcrumb: "Menu Content" } },
              { path: 'new/:menuId', component: MenuContentFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:menuId/:id', component: MenuContentFormComponent, data: { breadcrumb: "Edit" } }
            ]
          }
        ]
      },
      {
        path: 'cms-pages',
        data: { breadcrumb: "Cms Pages" },
        children: [
          { path: '', component: CmsPageListComponent, data: { breadcrumb: "Notice Boards" } },
          { path: 'new', component: CmsPageFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: CmsPageFormComponent, data: { breadcrumb: "Edit" } }
        ]
      },
      {
        path: 'feedbacks',
        data: { breadcrumb: "Feedbacks" },
        children: [
          { path: '', component: FeedbackListComponent, data: { breadcrumb: "Feedbacks" } },
          { path: 'new', component: FeedbackFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: FeedbackFormComponent, data: { breadcrumb: "Edit" } }
        ]
      },
      {
        path: 'notice-boards',
        data: { breadcrumb: "Notice Boards" },
        children: [
          { path: '', component: NoticeBoardListComponent, data: { breadcrumb: "Notice Boards" } },
          { path: 'new', component: NoticeBoardFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: NoticeBoardFormComponent, data: { breadcrumb: "Edit" } },
          {
            path: 'notice-board-categories',
            data: { breadcrumb: "Notice Board Categories" },
            children: [
              { path: '', component: NoticeBoardCategoryListComponent, data: { breadcrumb: "Notice Board Categories" } },
              { path: 'new', component: NoticeBoardCategoryFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:id', component: NoticeBoardCategoryFormComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'faqs',
        data: { breadcrumb: "FAQs" },
        children: [
          { path: '', component: FAQListComponent, data: { breadcrumb: "FAQs" } },
          { path: 'new', component: FAQFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: FAQFormComponent, data: { breadcrumb: "Edit" } },
          {
            path: 'faq-categories', data: { breadcrumb: "FAQ Categories" }, children: [
              { path: '', component: FAQCategoryListComponent, data: { breadcrumb: "FAQ Categories" } },
              { path: 'new', component: FAQCategoryFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:id', component: FAQCategoryFormComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'regions',
        data: { breadcrumb: "Regions" },
        children: [
          { path: '', component: RegionListComponent, data: { breadcrumb: "Regions" } },
          { path: 'new', component: RegionFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: RegionFormComponent, data: { breadcrumb: "Edit" } },
          {
            path: 'states',
            data: { breadcrumb: "States" },
            children: [
              { path: '', component: StateListComponent, data: { breadcrumb: "States" } },
              { path: 'new', component: StateFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:id', component: StateFormComponent, data: { breadcrumb: "Edit" } },
              {
                path: 'districts',
                data: { breadcrumb: "Districts" },
                children: [
                  { path: '', component: DistrictListComponent, data: { breadcrumb: "Districts" } },
                  { path: 'new', component: DistrictFormComponent, data: { breadcrumb: "New" } },
                  { path: 'edit/:id', component: DistrictFormComponent, data: { breadcrumb: "Edit" } },
                  {
                    path: 'schools',
                    data: { breadcrumb: "Schools" },
                    children: [
                      { path: '', component: SchoolListComponent, data: { breadcrumb: "Schools" } },
                      { path: 'new', component: SchoolFormComponent, data: { breadcrumb: "New" } },
                      { path: 'edit/:id', component: SchoolFormComponent, data: { breadcrumb: "Edit" } }
                    ]
                  },
                ]
              },
            ]
          },
        ]
      },
      {
        path: 'sanctioned-posts',
        data: { breadcrumb: "Sanctioned Posts" },
        children: [
          { path: '', component: SanctionedPostListComponent, data: { breadcrumb: "Sanctioned Posts" } },
          { path: 'new', component: SanctionedPostFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: SanctionedPostFormComponent, data: { breadcrumb: "Edit" } },
          {
            path: 'vacant-posts',
            data: { breadcrumb: "Vacant Posts" },
            children: [
              { path: '', component: VacantPostListComponent, data: { breadcrumb: "Vacant Posts" } },
              { path: 'new', component: VacantPostFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:id', component: VacantPostFormComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'employee-profile',
        data: { breadcrumb: "Employee Profile" },
        children: [
          { path: '', component: EmployeeProfileListComponent, data: { breadcrumb: "Employee Profile" } },
          { path: 'view-profile/:profileId/:financialYearId', component: EmployeeProfileViewComponent, data: { breadcrumb: "View Profile" } }
        ]
      },
      {
        path: 'grievance',
        data: { breadcrumb: 'Grievance List' },
        children: [
          { path: '', component: GrievanceComponent },
          { path: 'view-grievance', component: EmployerViewComponent, data: { breadcrumb: 'View Service Request' } },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
